<template>
  <v-dialog
    :value="loadingDialog"
    persistent
    max-width="290"
  >
    <v-card v-if="loadingDialog">
      <v-card-title class="headline" :class="{'error--text ': alert.error}">
        {{ alert.message }}
      </v-card-title>
      <v-card-text>
        <template v-if="alert.error && alert.errorTip">
          {{ alert.errorTip }}
        </template>
      </v-card-text>
      <v-card-actions>
        <template v-if="alert.error">
          <v-spacer></v-spacer>
          <v-btn color="success" flat @click="clearDialog(alert.id)">Ok</v-btn>
        </template>
        <template v-else>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="clearDialog(alert.id)">{{ alert.button_cancel_text }}</v-btn>
          <v-btn color="green darken-1" flat @click="setAgree(alert.id)">{{ alert.button_ok_text }}</v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Alert from '@/orm/models/Alert';

export default {
  name: 'dialogAlert',
  computed: {
    alert() {
      return Alert.query().first();
    },
    loadingDialog() {
      return !!this.alert;
    },
  },
  methods: {
    async clearDialog(id) {
      await Alert.delete(id);
    },
    async setAgree(id) {
      await Alert.update({
        where: id,
        data: {
          agree: true,
        },
      });
    },
  },
};
</script>
